import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/how-lucy-help-request-demo/how-lucy-help-request-demo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/how-lucy-help-you-hero/how-lucy-help-you-hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
